import * as PIXI from "pixi.js";
import { Logger } from "../../../util/log/Logger";
import { AbstractViewProperties } from "../../view/properties/AbstractViewProperties";
/**
 *  Use the editor to tweak config values:
 *  https://pixijs.io/pixi-particles-editor
 */
export class ParticleEmitterProperties extends AbstractViewProperties {
    constructor(position) {
        super(position);
        this.config = {};
        this.spriteProperties = [];
    }
    equals(other) {
        try {
            return this.spriteProperties.every((val, index) => val.equals(other[index])) &&
                (JSON.stringify(this.config) === JSON.stringify(other.config));
        }
        catch (e) {
            //just in case stringify throws an error
            Logger.error(e.message);
            return false;
        }
    }
    getImages() {
        let images = [];
        for (let properties of this.spriteProperties) {
            images.push(PIXI.Texture.from(properties.spriteSheet + "-" + properties.id));
        }
        return images;
    }
    getConfig() {
        return this.config;
    }
}
//# sourceMappingURL=ParticleEmitterProperties.js.map